export default {
  en: {
    // exampleProp: 'Example prop',
  },
};
